var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.375C0 0.615609 0.615609 0 1.375 0H10.625C11.3844 0 12 0.615609 12 1.375C12 2.13439 11.3844 2.75 10.625 2.75H1.375C0.615608 2.75 0 2.13439 0 1.375Z",
    fill: "#FFF4E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.625C0 9.86561 0.615609 9.25 1.375 9.25H10.625C11.3844 9.25 12 9.86561 12 10.625C12 11.3844 11.3844 12 10.625 12H1.375C0.615608 12 0 11.3844 0 10.625Z",
    fill: "#FFF4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.005C0 5.24561 0.615609 4.63 1.375 4.63H10.625C11.3844 4.63 12 5.24561 12 6.005C12 6.76439 11.3844 7.38 10.625 7.38H1.375C0.615608 7.38 0 6.76439 0 6.005Z",
    fill: "#FFF4E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeLines);
export default __webpack_public_path__ + "static/media/three-lines.9258a82a8ffba696afc3a056f013490b.svg";
export { ForwardRef as ReactComponent };